import { isApiError } from './apiError'
import { AbortError } from './requests'

export async function getWithConditionalRetry<T>({
  get,
  shouldRetry,
  shouldRetryError,
  interval = 1000,
  signal
}: {
  get: () => Promise<T>
  shouldRetry: (value: T, attemptsSoFar: number) => boolean
  shouldRetryError?: (error: unknown, errorCount: number) => boolean
  interval?: number
  signal?: AbortSignal
}): Promise<T> {
  // eslint-disable-next-line no-constant-condition
  let errorCount = 0
  let attemptsSoFar = 0
  while (!signal?.aborted) {
    let value
    try {
      value = await get()
      errorCount = 0
    } catch (error) {
      if (shouldRetryError?.(error, ++errorCount)) {
        await new Promise((resolve) => setTimeout(resolve, interval))
        continue
      } else {
        throw error
      }
    }
    if (!shouldRetry(value, ++attemptsSoFar)) {
      return value
    }
    await new Promise((resolve) => setTimeout(resolve, interval))
  }
  throw new AbortError()
}

export function isTransientNetworkError(error: unknown) {
  // this is thrown by fetch synchronousely when computer is offline
  if (error instanceof Error) {
    if (error.message === 'Failed to fetch') {
      return true
    }
  }

  // 502 Bad Gateway
  // 503 Service Unavailable
  // 504 Gateway Timeout
  if (isApiError(error) && (error.status === 503 || error.status === 502 || error.status === 504)) {
    return true
  }
  return false
}
